// source: account.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var annotations_pb = require('./annotations_pb.js');
goog.object.extend(proto, annotations_pb);
var api_pb = require('./api_pb.js');
goog.object.extend(proto, api_pb);
var auth_pb = require('./auth_pb.js');
goog.object.extend(proto, auth_pb);
var references_pb = require('./references_pb.js');
goog.object.extend(proto, references_pb);
goog.exportSymbol('proto.org.couchers.api.account.ActiveSession', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ChangeEmailV2Req', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ChangeLanguagePreferenceReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ChangePasswordV2Req', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ChangePhoneReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.CompleteMyHomeReminder', null, global);
goog.exportSymbol('proto.org.couchers.api.account.CompleteProfileReminder', null, global);
goog.exportSymbol('proto.org.couchers.api.account.CompleteVerificationReminder', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ConfirmHostRequestReminder', null, global);
goog.exportSymbol('proto.org.couchers.api.account.CreateInviteCodeReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.CreateInviteCodeRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.DeleteAccountReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.DisableInviteCodeReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.FillContributorFormReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.GetAccountInfoRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.GetContributorFormInfoRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.GetMyVolunteerInfoRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.GetRemindersRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.InitiateStrongVerificationRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.InviteCodeInfo', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ListActiveSessionsReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ListActiveSessionsRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ListInviteCodesRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ListModNotesRes', null, global);
goog.exportSymbol('proto.org.couchers.api.account.LogOutOtherSessionsReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.LogOutSessionReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ModNote', null, global);
goog.exportSymbol('proto.org.couchers.api.account.ProfilePublicVisibility', null, global);
goog.exportSymbol('proto.org.couchers.api.account.Reminder', null, global);
goog.exportSymbol('proto.org.couchers.api.account.Reminder.ReminderCase', null, global);
goog.exportSymbol('proto.org.couchers.api.account.RespondToHostRequestReminder', null, global);
goog.exportSymbol('proto.org.couchers.api.account.SetProfilePublicVisibilityReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.StrongVerificationAttemptStatus', null, global);
goog.exportSymbol('proto.org.couchers.api.account.UpdateMyVolunteerInfoReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.VerifyPhoneReq', null, global);
goog.exportSymbol('proto.org.couchers.api.account.WriteReferenceReminder', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.GetAccountInfoRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.GetAccountInfoRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.GetAccountInfoRes.displayName = 'proto.org.couchers.api.account.GetAccountInfoRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ChangePasswordV2Req = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.ChangePasswordV2Req, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ChangePasswordV2Req.displayName = 'proto.org.couchers.api.account.ChangePasswordV2Req';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ChangeEmailV2Req = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.ChangeEmailV2Req, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ChangeEmailV2Req.displayName = 'proto.org.couchers.api.account.ChangeEmailV2Req';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ChangeLanguagePreferenceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.ChangeLanguagePreferenceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ChangeLanguagePreferenceReq.displayName = 'proto.org.couchers.api.account.ChangeLanguagePreferenceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.GetContributorFormInfoRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.GetContributorFormInfoRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.GetContributorFormInfoRes.displayName = 'proto.org.couchers.api.account.GetContributorFormInfoRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.FillContributorFormReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.FillContributorFormReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.FillContributorFormReq.displayName = 'proto.org.couchers.api.account.FillContributorFormReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ChangePhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.ChangePhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ChangePhoneReq.displayName = 'proto.org.couchers.api.account.ChangePhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.VerifyPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.VerifyPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.VerifyPhoneReq.displayName = 'proto.org.couchers.api.account.VerifyPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.InitiateStrongVerificationRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.InitiateStrongVerificationRes.displayName = 'proto.org.couchers.api.account.InitiateStrongVerificationRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.displayName = 'proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.displayName = 'proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.DeleteAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.DeleteAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.DeleteAccountReq.displayName = 'proto.org.couchers.api.account.DeleteAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ModNote = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.ModNote, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ModNote.displayName = 'proto.org.couchers.api.account.ModNote';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ListModNotesRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.api.account.ListModNotesRes.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.api.account.ListModNotesRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ListModNotesRes.displayName = 'proto.org.couchers.api.account.ListModNotesRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ListActiveSessionsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.ListActiveSessionsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ListActiveSessionsReq.displayName = 'proto.org.couchers.api.account.ListActiveSessionsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ActiveSession = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.ActiveSession, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ActiveSession.displayName = 'proto.org.couchers.api.account.ActiveSession';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ListActiveSessionsRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.api.account.ListActiveSessionsRes.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.api.account.ListActiveSessionsRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ListActiveSessionsRes.displayName = 'proto.org.couchers.api.account.ListActiveSessionsRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.LogOutSessionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.LogOutSessionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.LogOutSessionReq.displayName = 'proto.org.couchers.api.account.LogOutSessionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.LogOutOtherSessionsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.LogOutOtherSessionsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.LogOutOtherSessionsReq.displayName = 'proto.org.couchers.api.account.LogOutOtherSessionsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.SetProfilePublicVisibilityReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.SetProfilePublicVisibilityReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.SetProfilePublicVisibilityReq.displayName = 'proto.org.couchers.api.account.SetProfilePublicVisibilityReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.CreateInviteCodeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.CreateInviteCodeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.CreateInviteCodeReq.displayName = 'proto.org.couchers.api.account.CreateInviteCodeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.CreateInviteCodeRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.CreateInviteCodeRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.CreateInviteCodeRes.displayName = 'proto.org.couchers.api.account.CreateInviteCodeRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.DisableInviteCodeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.DisableInviteCodeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.DisableInviteCodeReq.displayName = 'proto.org.couchers.api.account.DisableInviteCodeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.InviteCodeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.InviteCodeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.InviteCodeInfo.displayName = 'proto.org.couchers.api.account.InviteCodeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ListInviteCodesRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.api.account.ListInviteCodesRes.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.api.account.ListInviteCodesRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ListInviteCodesRes.displayName = 'proto.org.couchers.api.account.ListInviteCodesRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.CompleteProfileReminder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.CompleteProfileReminder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.CompleteProfileReminder.displayName = 'proto.org.couchers.api.account.CompleteProfileReminder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.CompleteMyHomeReminder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.CompleteMyHomeReminder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.CompleteMyHomeReminder.displayName = 'proto.org.couchers.api.account.CompleteMyHomeReminder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.CompleteVerificationReminder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.CompleteVerificationReminder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.CompleteVerificationReminder.displayName = 'proto.org.couchers.api.account.CompleteVerificationReminder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.RespondToHostRequestReminder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.RespondToHostRequestReminder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.RespondToHostRequestReminder.displayName = 'proto.org.couchers.api.account.RespondToHostRequestReminder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.ConfirmHostRequestReminder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.ConfirmHostRequestReminder.displayName = 'proto.org.couchers.api.account.ConfirmHostRequestReminder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.WriteReferenceReminder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.WriteReferenceReminder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.WriteReferenceReminder.displayName = 'proto.org.couchers.api.account.WriteReferenceReminder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.Reminder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.couchers.api.account.Reminder.oneofGroups_);
};
goog.inherits(proto.org.couchers.api.account.Reminder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.Reminder.displayName = 'proto.org.couchers.api.account.Reminder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.GetRemindersRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.api.account.GetRemindersRes.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.api.account.GetRemindersRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.GetRemindersRes.displayName = 'proto.org.couchers.api.account.GetRemindersRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.GetMyVolunteerInfoRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.GetMyVolunteerInfoRes.displayName = 'proto.org.couchers.api.account.GetMyVolunteerInfoRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.account.UpdateMyVolunteerInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.displayName = 'proto.org.couchers.api.account.UpdateMyVolunteerInfoReq';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.GetAccountInfoRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.GetAccountInfoRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetAccountInfoRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 7, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    profileComplete: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    myHomeComplete: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    phone: jspb.Message.getFieldWithDefault(msg, 8, ""),
    phoneVerified: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    timezone: jspb.Message.getFieldWithDefault(msg, 6, ""),
    hasDonated: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    hasStrongVerification: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    birthdateVerificationStatus: jspb.Message.getFieldWithDefault(msg, 11, 0),
    genderVerificationStatus: jspb.Message.getFieldWithDefault(msg, 12, 0),
    doNotEmail: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    isSuperuser: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    uiLanguagePreference: jspb.Message.getFieldWithDefault(msg, 16, ""),
    profilePublicVisibility: jspb.Message.getFieldWithDefault(msg, 17, 0),
    isVolunteer: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    shouldShowDonationBanner: jspb.Message.getBooleanFieldWithDefault(msg, 20, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes}
 */
proto.org.couchers.api.account.GetAccountInfoRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.GetAccountInfoRes;
  return proto.org.couchers.api.account.GetAccountInfoRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.GetAccountInfoRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes}
 */
proto.org.couchers.api.account.GetAccountInfoRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProfileComplete(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMyHomeComplete(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPhoneVerified(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasDonated(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasStrongVerification(value);
      break;
    case 11:
      var value = /** @type {!proto.org.couchers.api.core.BirthdateVerificationStatus} */ (reader.readEnum());
      msg.setBirthdateVerificationStatus(value);
      break;
    case 12:
      var value = /** @type {!proto.org.couchers.api.core.GenderVerificationStatus} */ (reader.readEnum());
      msg.setGenderVerificationStatus(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDoNotEmail(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuperuser(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setUiLanguagePreference(value);
      break;
    case 17:
      var value = /** @type {!proto.org.couchers.api.account.ProfilePublicVisibility} */ (reader.readEnum());
      msg.setProfilePublicVisibility(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsVolunteer(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldShowDonationBanner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.GetAccountInfoRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.GetAccountInfoRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetAccountInfoRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProfileComplete();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getMyHomeComplete();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPhoneVerified();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getHasDonated();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getHasStrongVerification();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getBirthdateVerificationStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getGenderVerificationStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getDoNotEmail();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getIsSuperuser();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getUiLanguagePreference();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getProfilePublicVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getIsVolunteer();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getShouldShowDonationBanner();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
};


/**
 * optional string username = 7;
 * @return {string}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool profile_complete = 4;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getProfileComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setProfileComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool my_home_complete = 19;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getMyHomeComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setMyHomeComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional string phone = 8;
 * @return {string}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool phone_verified = 9;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getPhoneVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setPhoneVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional string timezone = 6;
 * @return {string}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool has_donated = 14;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getHasDonated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setHasDonated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool has_strong_verification = 10;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getHasStrongVerification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setHasStrongVerification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional org.couchers.api.core.BirthdateVerificationStatus birthdate_verification_status = 11;
 * @return {!proto.org.couchers.api.core.BirthdateVerificationStatus}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getBirthdateVerificationStatus = function() {
  return /** @type {!proto.org.couchers.api.core.BirthdateVerificationStatus} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.org.couchers.api.core.BirthdateVerificationStatus} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setBirthdateVerificationStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional org.couchers.api.core.GenderVerificationStatus gender_verification_status = 12;
 * @return {!proto.org.couchers.api.core.GenderVerificationStatus}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getGenderVerificationStatus = function() {
  return /** @type {!proto.org.couchers.api.core.GenderVerificationStatus} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.org.couchers.api.core.GenderVerificationStatus} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setGenderVerificationStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional bool do_not_email = 13;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getDoNotEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setDoNotEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool is_superuser = 15;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getIsSuperuser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setIsSuperuser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string ui_language_preference = 16;
 * @return {string}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getUiLanguagePreference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setUiLanguagePreference = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional ProfilePublicVisibility profile_public_visibility = 17;
 * @return {!proto.org.couchers.api.account.ProfilePublicVisibility}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getProfilePublicVisibility = function() {
  return /** @type {!proto.org.couchers.api.account.ProfilePublicVisibility} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.org.couchers.api.account.ProfilePublicVisibility} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setProfilePublicVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional bool is_volunteer = 18;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getIsVolunteer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setIsVolunteer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional bool should_show_donation_banner = 20;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.getShouldShowDonationBanner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetAccountInfoRes} returns this
 */
proto.org.couchers.api.account.GetAccountInfoRes.prototype.setShouldShowDonationBanner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ChangePasswordV2Req.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ChangePasswordV2Req.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ChangePasswordV2Req} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ChangePasswordV2Req.toObject = function(includeInstance, msg) {
  var f, obj = {
    oldPassword: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newPassword: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ChangePasswordV2Req}
 */
proto.org.couchers.api.account.ChangePasswordV2Req.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ChangePasswordV2Req;
  return proto.org.couchers.api.account.ChangePasswordV2Req.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ChangePasswordV2Req} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ChangePasswordV2Req}
 */
proto.org.couchers.api.account.ChangePasswordV2Req.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOldPassword(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ChangePasswordV2Req.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ChangePasswordV2Req.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ChangePasswordV2Req} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ChangePasswordV2Req.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOldPassword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string old_password = 1;
 * @return {string}
 */
proto.org.couchers.api.account.ChangePasswordV2Req.prototype.getOldPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ChangePasswordV2Req} returns this
 */
proto.org.couchers.api.account.ChangePasswordV2Req.prototype.setOldPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string new_password = 2;
 * @return {string}
 */
proto.org.couchers.api.account.ChangePasswordV2Req.prototype.getNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ChangePasswordV2Req} returns this
 */
proto.org.couchers.api.account.ChangePasswordV2Req.prototype.setNewPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ChangeEmailV2Req.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ChangeEmailV2Req.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ChangeEmailV2Req} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ChangeEmailV2Req.toObject = function(includeInstance, msg) {
  var f, obj = {
    password: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newEmail: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ChangeEmailV2Req}
 */
proto.org.couchers.api.account.ChangeEmailV2Req.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ChangeEmailV2Req;
  return proto.org.couchers.api.account.ChangeEmailV2Req.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ChangeEmailV2Req} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ChangeEmailV2Req}
 */
proto.org.couchers.api.account.ChangeEmailV2Req.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ChangeEmailV2Req.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ChangeEmailV2Req.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ChangeEmailV2Req} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ChangeEmailV2Req.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string password = 1;
 * @return {string}
 */
proto.org.couchers.api.account.ChangeEmailV2Req.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ChangeEmailV2Req} returns this
 */
proto.org.couchers.api.account.ChangeEmailV2Req.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string new_email = 2;
 * @return {string}
 */
proto.org.couchers.api.account.ChangeEmailV2Req.prototype.getNewEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ChangeEmailV2Req} returns this
 */
proto.org.couchers.api.account.ChangeEmailV2Req.prototype.setNewEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ChangeLanguagePreferenceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ChangeLanguagePreferenceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ChangeLanguagePreferenceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ChangeLanguagePreferenceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    uiLanguagePreference: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ChangeLanguagePreferenceReq}
 */
proto.org.couchers.api.account.ChangeLanguagePreferenceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ChangeLanguagePreferenceReq;
  return proto.org.couchers.api.account.ChangeLanguagePreferenceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ChangeLanguagePreferenceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ChangeLanguagePreferenceReq}
 */
proto.org.couchers.api.account.ChangeLanguagePreferenceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUiLanguagePreference(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ChangeLanguagePreferenceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ChangeLanguagePreferenceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ChangeLanguagePreferenceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ChangeLanguagePreferenceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUiLanguagePreference();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ui_language_preference = 1;
 * @return {string}
 */
proto.org.couchers.api.account.ChangeLanguagePreferenceReq.prototype.getUiLanguagePreference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ChangeLanguagePreferenceReq} returns this
 */
proto.org.couchers.api.account.ChangeLanguagePreferenceReq.prototype.setUiLanguagePreference = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.GetContributorFormInfoRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.GetContributorFormInfoRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.GetContributorFormInfoRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetContributorFormInfoRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    filledContributorForm: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.GetContributorFormInfoRes}
 */
proto.org.couchers.api.account.GetContributorFormInfoRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.GetContributorFormInfoRes;
  return proto.org.couchers.api.account.GetContributorFormInfoRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.GetContributorFormInfoRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.GetContributorFormInfoRes}
 */
proto.org.couchers.api.account.GetContributorFormInfoRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilledContributorForm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.GetContributorFormInfoRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.GetContributorFormInfoRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.GetContributorFormInfoRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetContributorFormInfoRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilledContributorForm();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool filled_contributor_form = 1;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetContributorFormInfoRes.prototype.getFilledContributorForm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetContributorFormInfoRes} returns this
 */
proto.org.couchers.api.account.GetContributorFormInfoRes.prototype.setFilledContributorForm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.FillContributorFormReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.FillContributorFormReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.FillContributorFormReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.FillContributorFormReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    contributorForm: (f = msg.getContributorForm()) && auth_pb.ContributorForm.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.FillContributorFormReq}
 */
proto.org.couchers.api.account.FillContributorFormReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.FillContributorFormReq;
  return proto.org.couchers.api.account.FillContributorFormReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.FillContributorFormReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.FillContributorFormReq}
 */
proto.org.couchers.api.account.FillContributorFormReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new auth_pb.ContributorForm;
      reader.readMessage(value,auth_pb.ContributorForm.deserializeBinaryFromReader);
      msg.setContributorForm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.FillContributorFormReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.FillContributorFormReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.FillContributorFormReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.FillContributorFormReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContributorForm();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      auth_pb.ContributorForm.serializeBinaryToWriter
    );
  }
};


/**
 * optional org.couchers.auth.ContributorForm contributor_form = 1;
 * @return {?proto.org.couchers.auth.ContributorForm}
 */
proto.org.couchers.api.account.FillContributorFormReq.prototype.getContributorForm = function() {
  return /** @type{?proto.org.couchers.auth.ContributorForm} */ (
    jspb.Message.getWrapperField(this, auth_pb.ContributorForm, 1));
};


/**
 * @param {?proto.org.couchers.auth.ContributorForm|undefined} value
 * @return {!proto.org.couchers.api.account.FillContributorFormReq} returns this
*/
proto.org.couchers.api.account.FillContributorFormReq.prototype.setContributorForm = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.FillContributorFormReq} returns this
 */
proto.org.couchers.api.account.FillContributorFormReq.prototype.clearContributorForm = function() {
  return this.setContributorForm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.FillContributorFormReq.prototype.hasContributorForm = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ChangePhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ChangePhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ChangePhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ChangePhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    phone: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ChangePhoneReq}
 */
proto.org.couchers.api.account.ChangePhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ChangePhoneReq;
  return proto.org.couchers.api.account.ChangePhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ChangePhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ChangePhoneReq}
 */
proto.org.couchers.api.account.ChangePhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ChangePhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ChangePhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ChangePhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ChangePhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string phone = 1;
 * @return {string}
 */
proto.org.couchers.api.account.ChangePhoneReq.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ChangePhoneReq} returns this
 */
proto.org.couchers.api.account.ChangePhoneReq.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.VerifyPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.VerifyPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.VerifyPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.VerifyPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.VerifyPhoneReq}
 */
proto.org.couchers.api.account.VerifyPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.VerifyPhoneReq;
  return proto.org.couchers.api.account.VerifyPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.VerifyPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.VerifyPhoneReq}
 */
proto.org.couchers.api.account.VerifyPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.VerifyPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.VerifyPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.VerifyPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.VerifyPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.org.couchers.api.account.VerifyPhoneReq.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.VerifyPhoneReq} returns this
 */
proto.org.couchers.api.account.VerifyPhoneReq.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.InitiateStrongVerificationRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.InitiateStrongVerificationRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    verificationAttemptToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    redirectUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.InitiateStrongVerificationRes}
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.InitiateStrongVerificationRes;
  return proto.org.couchers.api.account.InitiateStrongVerificationRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.InitiateStrongVerificationRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.InitiateStrongVerificationRes}
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationAttemptToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.InitiateStrongVerificationRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.InitiateStrongVerificationRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationAttemptToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string verification_attempt_token = 1;
 * @return {string}
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.prototype.getVerificationAttemptToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.InitiateStrongVerificationRes} returns this
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.prototype.setVerificationAttemptToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string redirect_url = 3;
 * @return {string}
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.InitiateStrongVerificationRes} returns this
 */
proto.org.couchers.api.account.InitiateStrongVerificationRes.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    verificationAttemptToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq;
  return proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationAttemptToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationAttemptToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string verification_attempt_token = 1;
 * @return {string}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.prototype.getVerificationAttemptToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq} returns this
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusReq.prototype.setVerificationAttemptToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes;
  return proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.couchers.api.account.StrongVerificationAttemptStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional StrongVerificationAttemptStatus status = 1;
 * @return {!proto.org.couchers.api.account.StrongVerificationAttemptStatus}
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.prototype.getStatus = function() {
  return /** @type {!proto.org.couchers.api.account.StrongVerificationAttemptStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.couchers.api.account.StrongVerificationAttemptStatus} value
 * @return {!proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes} returns this
 */
proto.org.couchers.api.account.GetStrongVerificationAttemptStatusRes.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.DeleteAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.DeleteAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.DeleteAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.DeleteAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    confirm: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.DeleteAccountReq}
 */
proto.org.couchers.api.account.DeleteAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.DeleteAccountReq;
  return proto.org.couchers.api.account.DeleteAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.DeleteAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.DeleteAccountReq}
 */
proto.org.couchers.api.account.DeleteAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConfirm(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.DeleteAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.DeleteAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.DeleteAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.DeleteAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfirm();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool confirm = 1;
 * @return {boolean}
 */
proto.org.couchers.api.account.DeleteAccountReq.prototype.getConfirm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.DeleteAccountReq} returns this
 */
proto.org.couchers.api.account.DeleteAccountReq.prototype.setConfirm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.org.couchers.api.account.DeleteAccountReq.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.DeleteAccountReq} returns this
 */
proto.org.couchers.api.account.DeleteAccountReq.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ModNote.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ModNote.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ModNote} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ModNote.toObject = function(includeInstance, msg) {
  var f, obj = {
    noteId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    noteContent: jspb.Message.getFieldWithDefault(msg, 2, ""),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    acknowledged: (f = msg.getAcknowledged()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ModNote}
 */
proto.org.couchers.api.account.ModNote.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ModNote;
  return proto.org.couchers.api.account.ModNote.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ModNote} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ModNote}
 */
proto.org.couchers.api.account.ModNote.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setNoteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNoteContent(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAcknowledged(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ModNote.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ModNote.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ModNote} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ModNote.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getNoteContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAcknowledged();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 note_id = 1;
 * @return {number}
 */
proto.org.couchers.api.account.ModNote.prototype.getNoteId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.account.ModNote} returns this
 */
proto.org.couchers.api.account.ModNote.prototype.setNoteId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string note_content = 2;
 * @return {string}
 */
proto.org.couchers.api.account.ModNote.prototype.getNoteContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ModNote} returns this
 */
proto.org.couchers.api.account.ModNote.prototype.setNoteContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp created = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.account.ModNote.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.account.ModNote} returns this
*/
proto.org.couchers.api.account.ModNote.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.ModNote} returns this
 */
proto.org.couchers.api.account.ModNote.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.ModNote.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp acknowledged = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.account.ModNote.prototype.getAcknowledged = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.account.ModNote} returns this
*/
proto.org.couchers.api.account.ModNote.prototype.setAcknowledged = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.ModNote} returns this
 */
proto.org.couchers.api.account.ModNote.prototype.clearAcknowledged = function() {
  return this.setAcknowledged(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.ModNote.prototype.hasAcknowledged = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.api.account.ListModNotesRes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ListModNotesRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ListModNotesRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ListModNotesRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ListModNotesRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    modNotesList: jspb.Message.toObjectList(msg.getModNotesList(),
    proto.org.couchers.api.account.ModNote.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ListModNotesRes}
 */
proto.org.couchers.api.account.ListModNotesRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ListModNotesRes;
  return proto.org.couchers.api.account.ListModNotesRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ListModNotesRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ListModNotesRes}
 */
proto.org.couchers.api.account.ListModNotesRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.couchers.api.account.ModNote;
      reader.readMessage(value,proto.org.couchers.api.account.ModNote.deserializeBinaryFromReader);
      msg.addModNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ListModNotesRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ListModNotesRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ListModNotesRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ListModNotesRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.couchers.api.account.ModNote.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ModNote mod_notes = 1;
 * @return {!Array<!proto.org.couchers.api.account.ModNote>}
 */
proto.org.couchers.api.account.ListModNotesRes.prototype.getModNotesList = function() {
  return /** @type{!Array<!proto.org.couchers.api.account.ModNote>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.couchers.api.account.ModNote, 1));
};


/**
 * @param {!Array<!proto.org.couchers.api.account.ModNote>} value
 * @return {!proto.org.couchers.api.account.ListModNotesRes} returns this
*/
proto.org.couchers.api.account.ListModNotesRes.prototype.setModNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.couchers.api.account.ModNote=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.api.account.ModNote}
 */
proto.org.couchers.api.account.ListModNotesRes.prototype.addModNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.couchers.api.account.ModNote, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.api.account.ListModNotesRes} returns this
 */
proto.org.couchers.api.account.ListModNotesRes.prototype.clearModNotesList = function() {
  return this.setModNotesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ListActiveSessionsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ListActiveSessionsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ListActiveSessionsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ListActiveSessionsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ListActiveSessionsReq}
 */
proto.org.couchers.api.account.ListActiveSessionsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ListActiveSessionsReq;
  return proto.org.couchers.api.account.ListActiveSessionsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ListActiveSessionsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ListActiveSessionsReq}
 */
proto.org.couchers.api.account.ListActiveSessionsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ListActiveSessionsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ListActiveSessionsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ListActiveSessionsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ListActiveSessionsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 page_size = 1;
 * @return {number}
 */
proto.org.couchers.api.account.ListActiveSessionsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.account.ListActiveSessionsReq} returns this
 */
proto.org.couchers.api.account.ListActiveSessionsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string page_token = 2;
 * @return {string}
 */
proto.org.couchers.api.account.ListActiveSessionsReq.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ListActiveSessionsReq} returns this
 */
proto.org.couchers.api.account.ListActiveSessionsReq.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ActiveSession.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ActiveSession.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ActiveSession} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ActiveSession.toObject = function(includeInstance, msg) {
  var f, obj = {
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    expiry: (f = msg.getExpiry()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    lastSeen: (f = msg.getLastSeen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    operatingSystem: jspb.Message.getFieldWithDefault(msg, 4, ""),
    browser: jspb.Message.getFieldWithDefault(msg, 5, ""),
    device: jspb.Message.getFieldWithDefault(msg, 6, ""),
    approximateLocation: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isCurrentSession: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ActiveSession}
 */
proto.org.couchers.api.account.ActiveSession.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ActiveSession;
  return proto.org.couchers.api.account.ActiveSession.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ActiveSession} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ActiveSession}
 */
proto.org.couchers.api.account.ActiveSession.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiry(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastSeen(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperatingSystem(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrowser(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDevice(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setApproximateLocation(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCurrentSession(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ActiveSession.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ActiveSession.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ActiveSession} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ActiveSession.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExpiry();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastSeen();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOperatingSystem();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBrowser();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDevice();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getApproximateLocation();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsCurrentSession();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp created = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.account.ActiveSession.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
*/
proto.org.couchers.api.account.ActiveSession.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
 */
proto.org.couchers.api.account.ActiveSession.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.ActiveSession.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp expiry = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.account.ActiveSession.prototype.getExpiry = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
*/
proto.org.couchers.api.account.ActiveSession.prototype.setExpiry = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
 */
proto.org.couchers.api.account.ActiveSession.prototype.clearExpiry = function() {
  return this.setExpiry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.ActiveSession.prototype.hasExpiry = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp last_seen = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.account.ActiveSession.prototype.getLastSeen = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
*/
proto.org.couchers.api.account.ActiveSession.prototype.setLastSeen = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
 */
proto.org.couchers.api.account.ActiveSession.prototype.clearLastSeen = function() {
  return this.setLastSeen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.ActiveSession.prototype.hasLastSeen = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string operating_system = 4;
 * @return {string}
 */
proto.org.couchers.api.account.ActiveSession.prototype.getOperatingSystem = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
 */
proto.org.couchers.api.account.ActiveSession.prototype.setOperatingSystem = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string browser = 5;
 * @return {string}
 */
proto.org.couchers.api.account.ActiveSession.prototype.getBrowser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
 */
proto.org.couchers.api.account.ActiveSession.prototype.setBrowser = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string device = 6;
 * @return {string}
 */
proto.org.couchers.api.account.ActiveSession.prototype.getDevice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
 */
proto.org.couchers.api.account.ActiveSession.prototype.setDevice = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string approximate_location = 7;
 * @return {string}
 */
proto.org.couchers.api.account.ActiveSession.prototype.getApproximateLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
 */
proto.org.couchers.api.account.ActiveSession.prototype.setApproximateLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_current_session = 8;
 * @return {boolean}
 */
proto.org.couchers.api.account.ActiveSession.prototype.getIsCurrentSession = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.ActiveSession} returns this
 */
proto.org.couchers.api.account.ActiveSession.prototype.setIsCurrentSession = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.api.account.ListActiveSessionsRes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ListActiveSessionsRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ListActiveSessionsRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ListActiveSessionsRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ListActiveSessionsRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    activeSessionsList: jspb.Message.toObjectList(msg.getActiveSessionsList(),
    proto.org.couchers.api.account.ActiveSession.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ListActiveSessionsRes}
 */
proto.org.couchers.api.account.ListActiveSessionsRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ListActiveSessionsRes;
  return proto.org.couchers.api.account.ListActiveSessionsRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ListActiveSessionsRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ListActiveSessionsRes}
 */
proto.org.couchers.api.account.ListActiveSessionsRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.couchers.api.account.ActiveSession;
      reader.readMessage(value,proto.org.couchers.api.account.ActiveSession.deserializeBinaryFromReader);
      msg.addActiveSessions(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ListActiveSessionsRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ListActiveSessionsRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ListActiveSessionsRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ListActiveSessionsRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActiveSessionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.couchers.api.account.ActiveSession.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated ActiveSession active_sessions = 1;
 * @return {!Array<!proto.org.couchers.api.account.ActiveSession>}
 */
proto.org.couchers.api.account.ListActiveSessionsRes.prototype.getActiveSessionsList = function() {
  return /** @type{!Array<!proto.org.couchers.api.account.ActiveSession>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.couchers.api.account.ActiveSession, 1));
};


/**
 * @param {!Array<!proto.org.couchers.api.account.ActiveSession>} value
 * @return {!proto.org.couchers.api.account.ListActiveSessionsRes} returns this
*/
proto.org.couchers.api.account.ListActiveSessionsRes.prototype.setActiveSessionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.couchers.api.account.ActiveSession=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.api.account.ActiveSession}
 */
proto.org.couchers.api.account.ListActiveSessionsRes.prototype.addActiveSessions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.couchers.api.account.ActiveSession, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.api.account.ListActiveSessionsRes} returns this
 */
proto.org.couchers.api.account.ListActiveSessionsRes.prototype.clearActiveSessionsList = function() {
  return this.setActiveSessionsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.couchers.api.account.ListActiveSessionsRes.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.ListActiveSessionsRes} returns this
 */
proto.org.couchers.api.account.ListActiveSessionsRes.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.LogOutSessionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.LogOutSessionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.LogOutSessionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.LogOutSessionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.LogOutSessionReq}
 */
proto.org.couchers.api.account.LogOutSessionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.LogOutSessionReq;
  return proto.org.couchers.api.account.LogOutSessionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.LogOutSessionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.LogOutSessionReq}
 */
proto.org.couchers.api.account.LogOutSessionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.LogOutSessionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.LogOutSessionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.LogOutSessionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.LogOutSessionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp created = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.account.LogOutSessionReq.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.account.LogOutSessionReq} returns this
*/
proto.org.couchers.api.account.LogOutSessionReq.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.LogOutSessionReq} returns this
 */
proto.org.couchers.api.account.LogOutSessionReq.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.LogOutSessionReq.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.LogOutOtherSessionsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.LogOutOtherSessionsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.LogOutOtherSessionsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.LogOutOtherSessionsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    confirm: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.LogOutOtherSessionsReq}
 */
proto.org.couchers.api.account.LogOutOtherSessionsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.LogOutOtherSessionsReq;
  return proto.org.couchers.api.account.LogOutOtherSessionsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.LogOutOtherSessionsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.LogOutOtherSessionsReq}
 */
proto.org.couchers.api.account.LogOutOtherSessionsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConfirm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.LogOutOtherSessionsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.LogOutOtherSessionsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.LogOutOtherSessionsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.LogOutOtherSessionsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfirm();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool confirm = 1;
 * @return {boolean}
 */
proto.org.couchers.api.account.LogOutOtherSessionsReq.prototype.getConfirm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.LogOutOtherSessionsReq} returns this
 */
proto.org.couchers.api.account.LogOutOtherSessionsReq.prototype.setConfirm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.SetProfilePublicVisibilityReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.SetProfilePublicVisibilityReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.SetProfilePublicVisibilityReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.SetProfilePublicVisibilityReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    profilePublicVisibility: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.SetProfilePublicVisibilityReq}
 */
proto.org.couchers.api.account.SetProfilePublicVisibilityReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.SetProfilePublicVisibilityReq;
  return proto.org.couchers.api.account.SetProfilePublicVisibilityReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.SetProfilePublicVisibilityReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.SetProfilePublicVisibilityReq}
 */
proto.org.couchers.api.account.SetProfilePublicVisibilityReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.couchers.api.account.ProfilePublicVisibility} */ (reader.readEnum());
      msg.setProfilePublicVisibility(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.SetProfilePublicVisibilityReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.SetProfilePublicVisibilityReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.SetProfilePublicVisibilityReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.SetProfilePublicVisibilityReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfilePublicVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ProfilePublicVisibility profile_public_visibility = 1;
 * @return {!proto.org.couchers.api.account.ProfilePublicVisibility}
 */
proto.org.couchers.api.account.SetProfilePublicVisibilityReq.prototype.getProfilePublicVisibility = function() {
  return /** @type {!proto.org.couchers.api.account.ProfilePublicVisibility} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.couchers.api.account.ProfilePublicVisibility} value
 * @return {!proto.org.couchers.api.account.SetProfilePublicVisibilityReq} returns this
 */
proto.org.couchers.api.account.SetProfilePublicVisibilityReq.prototype.setProfilePublicVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.CreateInviteCodeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.CreateInviteCodeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.CreateInviteCodeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CreateInviteCodeReq.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.CreateInviteCodeReq}
 */
proto.org.couchers.api.account.CreateInviteCodeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.CreateInviteCodeReq;
  return proto.org.couchers.api.account.CreateInviteCodeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.CreateInviteCodeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.CreateInviteCodeReq}
 */
proto.org.couchers.api.account.CreateInviteCodeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.CreateInviteCodeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.CreateInviteCodeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.CreateInviteCodeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CreateInviteCodeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.CreateInviteCodeRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.CreateInviteCodeRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.CreateInviteCodeRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CreateInviteCodeRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    url: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.CreateInviteCodeRes}
 */
proto.org.couchers.api.account.CreateInviteCodeRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.CreateInviteCodeRes;
  return proto.org.couchers.api.account.CreateInviteCodeRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.CreateInviteCodeRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.CreateInviteCodeRes}
 */
proto.org.couchers.api.account.CreateInviteCodeRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.CreateInviteCodeRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.CreateInviteCodeRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.CreateInviteCodeRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CreateInviteCodeRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.org.couchers.api.account.CreateInviteCodeRes.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.CreateInviteCodeRes} returns this
 */
proto.org.couchers.api.account.CreateInviteCodeRes.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.org.couchers.api.account.CreateInviteCodeRes.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.CreateInviteCodeRes} returns this
 */
proto.org.couchers.api.account.CreateInviteCodeRes.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.DisableInviteCodeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.DisableInviteCodeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.DisableInviteCodeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.DisableInviteCodeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.DisableInviteCodeReq}
 */
proto.org.couchers.api.account.DisableInviteCodeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.DisableInviteCodeReq;
  return proto.org.couchers.api.account.DisableInviteCodeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.DisableInviteCodeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.DisableInviteCodeReq}
 */
proto.org.couchers.api.account.DisableInviteCodeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.DisableInviteCodeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.DisableInviteCodeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.DisableInviteCodeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.DisableInviteCodeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.org.couchers.api.account.DisableInviteCodeReq.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.DisableInviteCodeReq} returns this
 */
proto.org.couchers.api.account.DisableInviteCodeReq.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.InviteCodeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.InviteCodeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.InviteCodeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    disabled: (f = msg.getDisabled()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    uses: jspb.Message.getFieldWithDefault(msg, 4, 0),
    url: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.InviteCodeInfo}
 */
proto.org.couchers.api.account.InviteCodeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.InviteCodeInfo;
  return proto.org.couchers.api.account.InviteCodeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.InviteCodeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.InviteCodeInfo}
 */
proto.org.couchers.api.account.InviteCodeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDisabled(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUses(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.InviteCodeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.InviteCodeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.InviteCodeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDisabled();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUses();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.InviteCodeInfo} returns this
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.account.InviteCodeInfo} returns this
*/
proto.org.couchers.api.account.InviteCodeInfo.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.InviteCodeInfo} returns this
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp disabled = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.getDisabled = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.account.InviteCodeInfo} returns this
*/
proto.org.couchers.api.account.InviteCodeInfo.prototype.setDisabled = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.InviteCodeInfo} returns this
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.clearDisabled = function() {
  return this.setDisabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.hasDisabled = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 uses = 4;
 * @return {number}
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.getUses = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.account.InviteCodeInfo} returns this
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.setUses = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.InviteCodeInfo} returns this
 */
proto.org.couchers.api.account.InviteCodeInfo.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.api.account.ListInviteCodesRes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ListInviteCodesRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ListInviteCodesRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ListInviteCodesRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ListInviteCodesRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteCodesList: jspb.Message.toObjectList(msg.getInviteCodesList(),
    proto.org.couchers.api.account.InviteCodeInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ListInviteCodesRes}
 */
proto.org.couchers.api.account.ListInviteCodesRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ListInviteCodesRes;
  return proto.org.couchers.api.account.ListInviteCodesRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ListInviteCodesRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ListInviteCodesRes}
 */
proto.org.couchers.api.account.ListInviteCodesRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.couchers.api.account.InviteCodeInfo;
      reader.readMessage(value,proto.org.couchers.api.account.InviteCodeInfo.deserializeBinaryFromReader);
      msg.addInviteCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ListInviteCodesRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ListInviteCodesRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ListInviteCodesRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ListInviteCodesRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteCodesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.couchers.api.account.InviteCodeInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InviteCodeInfo invite_codes = 1;
 * @return {!Array<!proto.org.couchers.api.account.InviteCodeInfo>}
 */
proto.org.couchers.api.account.ListInviteCodesRes.prototype.getInviteCodesList = function() {
  return /** @type{!Array<!proto.org.couchers.api.account.InviteCodeInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.couchers.api.account.InviteCodeInfo, 1));
};


/**
 * @param {!Array<!proto.org.couchers.api.account.InviteCodeInfo>} value
 * @return {!proto.org.couchers.api.account.ListInviteCodesRes} returns this
*/
proto.org.couchers.api.account.ListInviteCodesRes.prototype.setInviteCodesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.couchers.api.account.InviteCodeInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.api.account.InviteCodeInfo}
 */
proto.org.couchers.api.account.ListInviteCodesRes.prototype.addInviteCodes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.couchers.api.account.InviteCodeInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.api.account.ListInviteCodesRes} returns this
 */
proto.org.couchers.api.account.ListInviteCodesRes.prototype.clearInviteCodesList = function() {
  return this.setInviteCodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.CompleteProfileReminder.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.CompleteProfileReminder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.CompleteProfileReminder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CompleteProfileReminder.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.CompleteProfileReminder}
 */
proto.org.couchers.api.account.CompleteProfileReminder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.CompleteProfileReminder;
  return proto.org.couchers.api.account.CompleteProfileReminder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.CompleteProfileReminder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.CompleteProfileReminder}
 */
proto.org.couchers.api.account.CompleteProfileReminder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.CompleteProfileReminder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.CompleteProfileReminder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.CompleteProfileReminder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CompleteProfileReminder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.CompleteMyHomeReminder.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.CompleteMyHomeReminder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.CompleteMyHomeReminder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CompleteMyHomeReminder.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.CompleteMyHomeReminder}
 */
proto.org.couchers.api.account.CompleteMyHomeReminder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.CompleteMyHomeReminder;
  return proto.org.couchers.api.account.CompleteMyHomeReminder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.CompleteMyHomeReminder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.CompleteMyHomeReminder}
 */
proto.org.couchers.api.account.CompleteMyHomeReminder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.CompleteMyHomeReminder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.CompleteMyHomeReminder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.CompleteMyHomeReminder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CompleteMyHomeReminder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.CompleteVerificationReminder.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.CompleteVerificationReminder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.CompleteVerificationReminder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CompleteVerificationReminder.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.CompleteVerificationReminder}
 */
proto.org.couchers.api.account.CompleteVerificationReminder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.CompleteVerificationReminder;
  return proto.org.couchers.api.account.CompleteVerificationReminder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.CompleteVerificationReminder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.CompleteVerificationReminder}
 */
proto.org.couchers.api.account.CompleteVerificationReminder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.CompleteVerificationReminder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.CompleteVerificationReminder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.CompleteVerificationReminder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.CompleteVerificationReminder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.RespondToHostRequestReminder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.RespondToHostRequestReminder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.toObject = function(includeInstance, msg) {
  var f, obj = {
    hostRequestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    surferUser: (f = msg.getSurferUser()) && api_pb.LiteUser.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.RespondToHostRequestReminder}
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.RespondToHostRequestReminder;
  return proto.org.couchers.api.account.RespondToHostRequestReminder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.RespondToHostRequestReminder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.RespondToHostRequestReminder}
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHostRequestId(value);
      break;
    case 2:
      var value = new api_pb.LiteUser;
      reader.readMessage(value,api_pb.LiteUser.deserializeBinaryFromReader);
      msg.setSurferUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.RespondToHostRequestReminder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.RespondToHostRequestReminder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHostRequestId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSurferUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      api_pb.LiteUser.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 host_request_id = 1;
 * @return {number}
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.prototype.getHostRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.account.RespondToHostRequestReminder} returns this
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.prototype.setHostRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional org.couchers.api.core.LiteUser surfer_user = 2;
 * @return {?proto.org.couchers.api.core.LiteUser}
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.prototype.getSurferUser = function() {
  return /** @type{?proto.org.couchers.api.core.LiteUser} */ (
    jspb.Message.getWrapperField(this, api_pb.LiteUser, 2));
};


/**
 * @param {?proto.org.couchers.api.core.LiteUser|undefined} value
 * @return {!proto.org.couchers.api.account.RespondToHostRequestReminder} returns this
*/
proto.org.couchers.api.account.RespondToHostRequestReminder.prototype.setSurferUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.RespondToHostRequestReminder} returns this
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.prototype.clearSurferUser = function() {
  return this.setSurferUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.RespondToHostRequestReminder.prototype.hasSurferUser = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.ConfirmHostRequestReminder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.ConfirmHostRequestReminder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.toObject = function(includeInstance, msg) {
  var f, obj = {
    hostRequestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hostUser: (f = msg.getHostUser()) && api_pb.LiteUser.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.ConfirmHostRequestReminder}
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.ConfirmHostRequestReminder;
  return proto.org.couchers.api.account.ConfirmHostRequestReminder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.ConfirmHostRequestReminder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.ConfirmHostRequestReminder}
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHostRequestId(value);
      break;
    case 2:
      var value = new api_pb.LiteUser;
      reader.readMessage(value,api_pb.LiteUser.deserializeBinaryFromReader);
      msg.setHostUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.ConfirmHostRequestReminder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.ConfirmHostRequestReminder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHostRequestId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getHostUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      api_pb.LiteUser.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 host_request_id = 1;
 * @return {number}
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.prototype.getHostRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.account.ConfirmHostRequestReminder} returns this
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.prototype.setHostRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional org.couchers.api.core.LiteUser host_user = 2;
 * @return {?proto.org.couchers.api.core.LiteUser}
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.prototype.getHostUser = function() {
  return /** @type{?proto.org.couchers.api.core.LiteUser} */ (
    jspb.Message.getWrapperField(this, api_pb.LiteUser, 2));
};


/**
 * @param {?proto.org.couchers.api.core.LiteUser|undefined} value
 * @return {!proto.org.couchers.api.account.ConfirmHostRequestReminder} returns this
*/
proto.org.couchers.api.account.ConfirmHostRequestReminder.prototype.setHostUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.ConfirmHostRequestReminder} returns this
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.prototype.clearHostUser = function() {
  return this.setHostUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.ConfirmHostRequestReminder.prototype.hasHostUser = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.WriteReferenceReminder.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.WriteReferenceReminder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.WriteReferenceReminder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.WriteReferenceReminder.toObject = function(includeInstance, msg) {
  var f, obj = {
    hostRequestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    otherUser: (f = msg.getOtherUser()) && api_pb.LiteUser.toObject(includeInstance, f),
    referenceType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.WriteReferenceReminder}
 */
proto.org.couchers.api.account.WriteReferenceReminder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.WriteReferenceReminder;
  return proto.org.couchers.api.account.WriteReferenceReminder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.WriteReferenceReminder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.WriteReferenceReminder}
 */
proto.org.couchers.api.account.WriteReferenceReminder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHostRequestId(value);
      break;
    case 2:
      var value = new api_pb.LiteUser;
      reader.readMessage(value,api_pb.LiteUser.deserializeBinaryFromReader);
      msg.setOtherUser(value);
      break;
    case 3:
      var value = /** @type {!proto.org.couchers.api.references.ReferenceType} */ (reader.readEnum());
      msg.setReferenceType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.WriteReferenceReminder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.WriteReferenceReminder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.WriteReferenceReminder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.WriteReferenceReminder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHostRequestId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOtherUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      api_pb.LiteUser.serializeBinaryToWriter
    );
  }
  f = message.getReferenceType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int64 host_request_id = 1;
 * @return {number}
 */
proto.org.couchers.api.account.WriteReferenceReminder.prototype.getHostRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.account.WriteReferenceReminder} returns this
 */
proto.org.couchers.api.account.WriteReferenceReminder.prototype.setHostRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional org.couchers.api.core.LiteUser other_user = 2;
 * @return {?proto.org.couchers.api.core.LiteUser}
 */
proto.org.couchers.api.account.WriteReferenceReminder.prototype.getOtherUser = function() {
  return /** @type{?proto.org.couchers.api.core.LiteUser} */ (
    jspb.Message.getWrapperField(this, api_pb.LiteUser, 2));
};


/**
 * @param {?proto.org.couchers.api.core.LiteUser|undefined} value
 * @return {!proto.org.couchers.api.account.WriteReferenceReminder} returns this
*/
proto.org.couchers.api.account.WriteReferenceReminder.prototype.setOtherUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.WriteReferenceReminder} returns this
 */
proto.org.couchers.api.account.WriteReferenceReminder.prototype.clearOtherUser = function() {
  return this.setOtherUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.WriteReferenceReminder.prototype.hasOtherUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional org.couchers.api.references.ReferenceType reference_type = 3;
 * @return {!proto.org.couchers.api.references.ReferenceType}
 */
proto.org.couchers.api.account.WriteReferenceReminder.prototype.getReferenceType = function() {
  return /** @type {!proto.org.couchers.api.references.ReferenceType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.couchers.api.references.ReferenceType} value
 * @return {!proto.org.couchers.api.account.WriteReferenceReminder} returns this
 */
proto.org.couchers.api.account.WriteReferenceReminder.prototype.setReferenceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.couchers.api.account.Reminder.oneofGroups_ = [[1,2,3,4,5,6]];

/**
 * @enum {number}
 */
proto.org.couchers.api.account.Reminder.ReminderCase = {
  REMINDER_NOT_SET: 0,
  COMPLETE_PROFILE_REMINDER: 1,
  COMPLETE_VERIFICATION_REMINDER: 2,
  RESPOND_TO_HOST_REQUEST_REMINDER: 3,
  WRITE_REFERENCE_REMINDER: 4,
  COMPLETE_MY_HOME_REMINDER: 5,
  CONFIRM_HOST_REQUEST_REMINDER: 6
};

/**
 * @return {proto.org.couchers.api.account.Reminder.ReminderCase}
 */
proto.org.couchers.api.account.Reminder.prototype.getReminderCase = function() {
  return /** @type {proto.org.couchers.api.account.Reminder.ReminderCase} */(jspb.Message.computeOneofCase(this, proto.org.couchers.api.account.Reminder.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.Reminder.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.Reminder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.Reminder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.Reminder.toObject = function(includeInstance, msg) {
  var f, obj = {
    completeProfileReminder: (f = msg.getCompleteProfileReminder()) && proto.org.couchers.api.account.CompleteProfileReminder.toObject(includeInstance, f),
    completeVerificationReminder: (f = msg.getCompleteVerificationReminder()) && proto.org.couchers.api.account.CompleteVerificationReminder.toObject(includeInstance, f),
    respondToHostRequestReminder: (f = msg.getRespondToHostRequestReminder()) && proto.org.couchers.api.account.RespondToHostRequestReminder.toObject(includeInstance, f),
    writeReferenceReminder: (f = msg.getWriteReferenceReminder()) && proto.org.couchers.api.account.WriteReferenceReminder.toObject(includeInstance, f),
    completeMyHomeReminder: (f = msg.getCompleteMyHomeReminder()) && proto.org.couchers.api.account.CompleteMyHomeReminder.toObject(includeInstance, f),
    confirmHostRequestReminder: (f = msg.getConfirmHostRequestReminder()) && proto.org.couchers.api.account.ConfirmHostRequestReminder.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.Reminder}
 */
proto.org.couchers.api.account.Reminder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.Reminder;
  return proto.org.couchers.api.account.Reminder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.Reminder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.Reminder}
 */
proto.org.couchers.api.account.Reminder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.couchers.api.account.CompleteProfileReminder;
      reader.readMessage(value,proto.org.couchers.api.account.CompleteProfileReminder.deserializeBinaryFromReader);
      msg.setCompleteProfileReminder(value);
      break;
    case 2:
      var value = new proto.org.couchers.api.account.CompleteVerificationReminder;
      reader.readMessage(value,proto.org.couchers.api.account.CompleteVerificationReminder.deserializeBinaryFromReader);
      msg.setCompleteVerificationReminder(value);
      break;
    case 3:
      var value = new proto.org.couchers.api.account.RespondToHostRequestReminder;
      reader.readMessage(value,proto.org.couchers.api.account.RespondToHostRequestReminder.deserializeBinaryFromReader);
      msg.setRespondToHostRequestReminder(value);
      break;
    case 4:
      var value = new proto.org.couchers.api.account.WriteReferenceReminder;
      reader.readMessage(value,proto.org.couchers.api.account.WriteReferenceReminder.deserializeBinaryFromReader);
      msg.setWriteReferenceReminder(value);
      break;
    case 5:
      var value = new proto.org.couchers.api.account.CompleteMyHomeReminder;
      reader.readMessage(value,proto.org.couchers.api.account.CompleteMyHomeReminder.deserializeBinaryFromReader);
      msg.setCompleteMyHomeReminder(value);
      break;
    case 6:
      var value = new proto.org.couchers.api.account.ConfirmHostRequestReminder;
      reader.readMessage(value,proto.org.couchers.api.account.ConfirmHostRequestReminder.deserializeBinaryFromReader);
      msg.setConfirmHostRequestReminder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.Reminder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.Reminder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.Reminder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.Reminder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompleteProfileReminder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.couchers.api.account.CompleteProfileReminder.serializeBinaryToWriter
    );
  }
  f = message.getCompleteVerificationReminder();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.couchers.api.account.CompleteVerificationReminder.serializeBinaryToWriter
    );
  }
  f = message.getRespondToHostRequestReminder();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.couchers.api.account.RespondToHostRequestReminder.serializeBinaryToWriter
    );
  }
  f = message.getWriteReferenceReminder();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.org.couchers.api.account.WriteReferenceReminder.serializeBinaryToWriter
    );
  }
  f = message.getCompleteMyHomeReminder();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.couchers.api.account.CompleteMyHomeReminder.serializeBinaryToWriter
    );
  }
  f = message.getConfirmHostRequestReminder();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.org.couchers.api.account.ConfirmHostRequestReminder.serializeBinaryToWriter
    );
  }
};


/**
 * optional CompleteProfileReminder complete_profile_reminder = 1;
 * @return {?proto.org.couchers.api.account.CompleteProfileReminder}
 */
proto.org.couchers.api.account.Reminder.prototype.getCompleteProfileReminder = function() {
  return /** @type{?proto.org.couchers.api.account.CompleteProfileReminder} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.account.CompleteProfileReminder, 1));
};


/**
 * @param {?proto.org.couchers.api.account.CompleteProfileReminder|undefined} value
 * @return {!proto.org.couchers.api.account.Reminder} returns this
*/
proto.org.couchers.api.account.Reminder.prototype.setCompleteProfileReminder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.org.couchers.api.account.Reminder.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.Reminder} returns this
 */
proto.org.couchers.api.account.Reminder.prototype.clearCompleteProfileReminder = function() {
  return this.setCompleteProfileReminder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.Reminder.prototype.hasCompleteProfileReminder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CompleteVerificationReminder complete_verification_reminder = 2;
 * @return {?proto.org.couchers.api.account.CompleteVerificationReminder}
 */
proto.org.couchers.api.account.Reminder.prototype.getCompleteVerificationReminder = function() {
  return /** @type{?proto.org.couchers.api.account.CompleteVerificationReminder} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.account.CompleteVerificationReminder, 2));
};


/**
 * @param {?proto.org.couchers.api.account.CompleteVerificationReminder|undefined} value
 * @return {!proto.org.couchers.api.account.Reminder} returns this
*/
proto.org.couchers.api.account.Reminder.prototype.setCompleteVerificationReminder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.org.couchers.api.account.Reminder.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.Reminder} returns this
 */
proto.org.couchers.api.account.Reminder.prototype.clearCompleteVerificationReminder = function() {
  return this.setCompleteVerificationReminder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.Reminder.prototype.hasCompleteVerificationReminder = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RespondToHostRequestReminder respond_to_host_request_reminder = 3;
 * @return {?proto.org.couchers.api.account.RespondToHostRequestReminder}
 */
proto.org.couchers.api.account.Reminder.prototype.getRespondToHostRequestReminder = function() {
  return /** @type{?proto.org.couchers.api.account.RespondToHostRequestReminder} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.account.RespondToHostRequestReminder, 3));
};


/**
 * @param {?proto.org.couchers.api.account.RespondToHostRequestReminder|undefined} value
 * @return {!proto.org.couchers.api.account.Reminder} returns this
*/
proto.org.couchers.api.account.Reminder.prototype.setRespondToHostRequestReminder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.org.couchers.api.account.Reminder.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.Reminder} returns this
 */
proto.org.couchers.api.account.Reminder.prototype.clearRespondToHostRequestReminder = function() {
  return this.setRespondToHostRequestReminder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.Reminder.prototype.hasRespondToHostRequestReminder = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional WriteReferenceReminder write_reference_reminder = 4;
 * @return {?proto.org.couchers.api.account.WriteReferenceReminder}
 */
proto.org.couchers.api.account.Reminder.prototype.getWriteReferenceReminder = function() {
  return /** @type{?proto.org.couchers.api.account.WriteReferenceReminder} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.account.WriteReferenceReminder, 4));
};


/**
 * @param {?proto.org.couchers.api.account.WriteReferenceReminder|undefined} value
 * @return {!proto.org.couchers.api.account.Reminder} returns this
*/
proto.org.couchers.api.account.Reminder.prototype.setWriteReferenceReminder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.org.couchers.api.account.Reminder.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.Reminder} returns this
 */
proto.org.couchers.api.account.Reminder.prototype.clearWriteReferenceReminder = function() {
  return this.setWriteReferenceReminder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.Reminder.prototype.hasWriteReferenceReminder = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CompleteMyHomeReminder complete_my_home_reminder = 5;
 * @return {?proto.org.couchers.api.account.CompleteMyHomeReminder}
 */
proto.org.couchers.api.account.Reminder.prototype.getCompleteMyHomeReminder = function() {
  return /** @type{?proto.org.couchers.api.account.CompleteMyHomeReminder} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.account.CompleteMyHomeReminder, 5));
};


/**
 * @param {?proto.org.couchers.api.account.CompleteMyHomeReminder|undefined} value
 * @return {!proto.org.couchers.api.account.Reminder} returns this
*/
proto.org.couchers.api.account.Reminder.prototype.setCompleteMyHomeReminder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.org.couchers.api.account.Reminder.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.Reminder} returns this
 */
proto.org.couchers.api.account.Reminder.prototype.clearCompleteMyHomeReminder = function() {
  return this.setCompleteMyHomeReminder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.Reminder.prototype.hasCompleteMyHomeReminder = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ConfirmHostRequestReminder confirm_host_request_reminder = 6;
 * @return {?proto.org.couchers.api.account.ConfirmHostRequestReminder}
 */
proto.org.couchers.api.account.Reminder.prototype.getConfirmHostRequestReminder = function() {
  return /** @type{?proto.org.couchers.api.account.ConfirmHostRequestReminder} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.account.ConfirmHostRequestReminder, 6));
};


/**
 * @param {?proto.org.couchers.api.account.ConfirmHostRequestReminder|undefined} value
 * @return {!proto.org.couchers.api.account.Reminder} returns this
*/
proto.org.couchers.api.account.Reminder.prototype.setConfirmHostRequestReminder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.org.couchers.api.account.Reminder.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.Reminder} returns this
 */
proto.org.couchers.api.account.Reminder.prototype.clearConfirmHostRequestReminder = function() {
  return this.setConfirmHostRequestReminder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.Reminder.prototype.hasConfirmHostRequestReminder = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.api.account.GetRemindersRes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.GetRemindersRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.GetRemindersRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.GetRemindersRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetRemindersRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    remindersList: jspb.Message.toObjectList(msg.getRemindersList(),
    proto.org.couchers.api.account.Reminder.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.GetRemindersRes}
 */
proto.org.couchers.api.account.GetRemindersRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.GetRemindersRes;
  return proto.org.couchers.api.account.GetRemindersRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.GetRemindersRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.GetRemindersRes}
 */
proto.org.couchers.api.account.GetRemindersRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.couchers.api.account.Reminder;
      reader.readMessage(value,proto.org.couchers.api.account.Reminder.deserializeBinaryFromReader);
      msg.addReminders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.GetRemindersRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.GetRemindersRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.GetRemindersRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetRemindersRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRemindersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.couchers.api.account.Reminder.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Reminder reminders = 1;
 * @return {!Array<!proto.org.couchers.api.account.Reminder>}
 */
proto.org.couchers.api.account.GetRemindersRes.prototype.getRemindersList = function() {
  return /** @type{!Array<!proto.org.couchers.api.account.Reminder>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.couchers.api.account.Reminder, 1));
};


/**
 * @param {!Array<!proto.org.couchers.api.account.Reminder>} value
 * @return {!proto.org.couchers.api.account.GetRemindersRes} returns this
*/
proto.org.couchers.api.account.GetRemindersRes.prototype.setRemindersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.couchers.api.account.Reminder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.api.account.Reminder}
 */
proto.org.couchers.api.account.GetRemindersRes.prototype.addReminders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.couchers.api.account.Reminder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.api.account.GetRemindersRes} returns this
 */
proto.org.couchers.api.account.GetRemindersRes.prototype.clearRemindersList = function() {
  return this.setRemindersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.GetMyVolunteerInfoRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayLocation: jspb.Message.getFieldWithDefault(msg, 2, ""),
    role: jspb.Message.getFieldWithDefault(msg, 3, ""),
    startedVolunteering: jspb.Message.getFieldWithDefault(msg, 4, ""),
    stoppedVolunteering: jspb.Message.getFieldWithDefault(msg, 5, ""),
    showOnTeamPage: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    linkType: jspb.Message.getFieldWithDefault(msg, 7, ""),
    linkText: jspb.Message.getFieldWithDefault(msg, 8, ""),
    linkUrl: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.GetMyVolunteerInfoRes;
  return proto.org.couchers.api.account.GetMyVolunteerInfoRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayLocation(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartedVolunteering(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoppedVolunteering(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowOnTeamPage(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkText(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.GetMyVolunteerInfoRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayLocation();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStartedVolunteering();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStoppedVolunteering();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getShowOnTeamPage();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getLinkType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLinkText();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLinkUrl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string display_name = 1;
 * @return {string}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} returns this
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_location = 2;
 * @return {string}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.getDisplayLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} returns this
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.setDisplayLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string role = 3;
 * @return {string}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} returns this
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string started_volunteering = 4;
 * @return {string}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.getStartedVolunteering = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} returns this
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.setStartedVolunteering = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string stopped_volunteering = 5;
 * @return {string}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.getStoppedVolunteering = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} returns this
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.setStoppedVolunteering = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool show_on_team_page = 6;
 * @return {boolean}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.getShowOnTeamPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} returns this
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.setShowOnTeamPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string link_type = 7;
 * @return {string}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.getLinkType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} returns this
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.setLinkType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string link_text = 8;
 * @return {string}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.getLinkText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} returns this
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.setLinkText = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string link_url = 9;
 * @return {string}
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.getLinkUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.account.GetMyVolunteerInfoRes} returns this
 */
proto.org.couchers.api.account.GetMyVolunteerInfoRes.prototype.setLinkUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayName: (f = msg.getDisplayName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    displayLocation: (f = msg.getDisplayLocation()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    showOnTeamPage: (f = msg.getShowOnTeamPage()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    linkType: (f = msg.getLinkType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    linkText: (f = msg.getLinkText()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    linkUrl: (f = msg.getLinkUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.account.UpdateMyVolunteerInfoReq;
  return proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDisplayName(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDisplayLocation(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setShowOnTeamPage(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLinkType(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLinkText(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLinkUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDisplayLocation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getShowOnTeamPage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLinkType();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLinkText();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLinkUrl();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue display_name = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.getDisplayName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
*/
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.setDisplayName = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.clearDisplayName = function() {
  return this.setDisplayName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.hasDisplayName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue display_location = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.getDisplayLocation = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
*/
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.setDisplayLocation = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.clearDisplayLocation = function() {
  return this.setDisplayLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.hasDisplayLocation = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue show_on_team_page = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.getShowOnTeamPage = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
*/
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.setShowOnTeamPage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.clearShowOnTeamPage = function() {
  return this.setShowOnTeamPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.hasShowOnTeamPage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue link_type = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.getLinkType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
*/
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.setLinkType = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.clearLinkType = function() {
  return this.setLinkType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.hasLinkType = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue link_text = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.getLinkText = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
*/
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.setLinkText = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.clearLinkText = function() {
  return this.setLinkText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.hasLinkText = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue link_url = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.getLinkUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
*/
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.setLinkUrl = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.account.UpdateMyVolunteerInfoReq} returns this
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.clearLinkUrl = function() {
  return this.setLinkUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.account.UpdateMyVolunteerInfoReq.prototype.hasLinkUrl = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * @enum {number}
 */
proto.org.couchers.api.account.StrongVerificationAttemptStatus = {
  STRONG_VERIFICATION_ATTEMPT_STATUS_UNKNOWN: 0,
  STRONG_VERIFICATION_ATTEMPT_STATUS_SUCCEEDED: 1,
  STRONG_VERIFICATION_ATTEMPT_STATUS_IN_PROGRESS_WAITING_ON_USER_TO_OPEN_APP: 2,
  STRONG_VERIFICATION_ATTEMPT_STATUS_IN_PROGRESS_WAITING_ON_USER_IN_APP: 5,
  STRONG_VERIFICATION_ATTEMPT_STATUS_IN_PROGRESS_WAITING_ON_BACKEND: 3,
  STRONG_VERIFICATION_ATTEMPT_STATUS_FAILED: 4
};

/**
 * @enum {number}
 */
proto.org.couchers.api.account.ProfilePublicVisibility = {
  PROFILE_PUBLIC_VISIBILITY_UNKNOWN: 0,
  PROFILE_PUBLIC_VISIBILITY_NOTHING: 1,
  PROFILE_PUBLIC_VISIBILITY_MAP_ONLY: 2,
  PROFILE_PUBLIC_VISIBILITY_LIMITED: 3,
  PROFILE_PUBLIC_VISIBILITY_MOST: 4,
  PROFILE_PUBLIC_VISIBILITY_FULL: 5
};

goog.object.extend(exports, proto.org.couchers.api.account);
